import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Wallet from "./Wallet/Wallet";
import Card from "./Card/Card";
import International from "./International/International";
import { MdCancel } from "react-icons/md";
import { Stack } from "@mui/system";
import {
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  AccountBalanceWallet,
  ArrowBackIos,
  ArrowRightAlt,
  Clear,
} from "@mui/icons-material";
import swal from "sweetalert";
import { useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../store/useStore";

const decodeLocalData = (name) => {
  try {
    const encoded = window.localStorage.getItem(name);
    if (!encoded) return null;

    const decoded = atob(encoded);
    return JSON.parse(decoded);
  } catch (error) {
    console.warn(`Failed to decode localStorage["${name}"]:`, error);
    localStorage.removeItem(name); // clean up corrupted data
    return null;
  }
};


const PaymentMethodCashInModal = ({
  route,
  handleClose,
  open2,
  currentAmount,
  setCurrentAmount,
  note,
  setSelectedMethod,
  selectedMethod,
  getRefer,
  setGetRefer,
  dueAmount,
  currentCurrency,
  setCurrentCurrency,
  paymentInfo,
  handleCurrentCurrencyChange,
  payAmoOn,
  receiver,
  pay_service_refer,
  jobPage,
}) => {
  const navigate = useNavigate();
  const [toggleDisplay, setToggleDisplay] = useState(false);
  const [showNoteField, setShowNoteField] = useState(false);
  const [component, setComponent] = useState("");
  const [payAmount, setPayAmount] = useState("");
  const [memo, setMemo] = useState("");
   const [isLogged, setIsLogged] = useState(false);
    const [isLogin, setIsLogin] = useState(true);
  
const {
    user,
    setUser,
    poster,
    portal,
    cRefer,
    ip,
  } = useStore();

  const handlePayAmount = (e) => {
    setCurrentAmount(e.target.value);
  };
  const handleCurrencyChange = (e) => {
    setCurrentCurrency(e.target.value);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100%", md: 600 },
    height: "auto",
    backgroundColor: "background.paper",
    boxShadow: 24,
    borderRadius: 4,
    overflow: "auto",
    p: 4,
  };

   useEffect(() => {
      const isValidMember = !!(user?.refer && user?.sopnoid && user?.membership);
      const isValidLogin = !!user?.sopnoid;
  
      // setIsMember(isValidMember);
      setIsLogged(isValidLogin);
  
      const storedUser = decodeLocalData("gh_sl@g");
  
      if (!isValidLogin && storedUser) {
        try {
          const originMatches = storedUser?.origin === window.location.origin;
          const hasValidId = !!storedUser?.sopnoid;
  
          if (originMatches && hasValidId) {
            setUser(storedUser);
            setIsLogged(true);
            // setIsMember(!!(storedUser?.refer && storedUser?.membership));
          } else {
            localStorage.removeItem("gh_sl@g");
          }
        } catch (err) {
          console.error("Failed to parse stored user", err);
          localStorage.removeItem("gh_sl@g");
        }
      }
    }, [user]);
  

  useEffect(() => {
    setComponent(currentCurrency == 1 ? "Wallet" : "International");
  }, [currentCurrency]);

  const handleSaveInServer = () => {
    const formData = new FormData();
    let request_object = {};
    request_object.pay_refer = user?.sopnoid;
    request_object.acAmount = currentAmount;
    request_object.currency = currentCurrency;
    request_object.paytype = 1;
    request_object.acType = selectedMethod?.id;
    request_object.billing_state = 1;
    request_object.acNote = memo;
    request_object.receiver = receiver;
    request_object.poster = user?.sopnoid;
    request_object.c_refer = user?.c_refer;
    request_object.pay_service_refer = pay_service_refer;
    formData.append("pay_request", "serialized");
    formData.append("poster_id", user?.sopnoid);
    formData.append("c_refer", user?.c_refer);
    formData.append("request_object", JSON.stringify(request_object));

    fetch("https://aps.songjukti.com/profile/ac_bil/api_web/new/pay_new.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result?.[0]?.trnxid && result?.[0]?.verfify_tocken) {
          setGetRefer(result?.[0]?.trnxid);
          setToggleDisplay(true);
          // afterHit();
        }
        // setToggleDisplay(true);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  };


 const afterHit = (e) => {
    let parsedObject = decodeLocalData("gh_sl@g");

    const formData = new FormData();
    let url;
    let grandTotal = currentAmount;
    let orderId = getRefer;
    let order_id = getRefer;
    let organization = "songjukti";

    let orgranization = "songjukti";
    let currentCurrency = 2;
    let name = parsedObject?.uname;
    let phone = parsedObject?.umobile;
    let address = "dhaka";
    let email = parsedObject?.uemail;
    let sopnoId = parsedObject?.sopnoid;
    let myReurnUrl = "https://user.songjukti.com/success/";
    let portalLogo =
      "https://aps.songjukti.com/static/media/songjukti.064fb2e32388b8ea26c2.ico";
    let brandId = "songjukti";

    const form = document.createElement("form");
    form.method = "POST";
    if (selectedMethod?.name == "nagad") {
      form.action = "//yeapbe.com/ghpay/nagad/index.php";
      // Sample 1
      const hiddenFieldSample1 = document.createElement("input");
      hiddenFieldSample1.type = "hidden";
      hiddenFieldSample1.name = "cname";
      hiddenFieldSample1.value = sopnoId?.slice(0, 7);
      form.appendChild(hiddenFieldSample1);

      // Sample 2
      const hiddenFieldSample2 = document.createElement("input");
      hiddenFieldSample2.type = "hidden";
      hiddenFieldSample2.name = "pamount";
      hiddenFieldSample2.value = currentAmount;
      form.appendChild(hiddenFieldSample2);
      // Sample 2

      const hiddenFieldSample3 = document.createElement("input");
      hiddenFieldSample3.type = "hidden";
      hiddenFieldSample3.name = "order_id";
      hiddenFieldSample3.value = getRefer;
      // hiddenFieldSample3.value = Math.round(Math.random() * 1000000000 + 1);
      form.appendChild(hiddenFieldSample3);

      // Sample 2
      const hiddenFieldSample4 = document.createElement("input");
      hiddenFieldSample4.type = "hidden";
      hiddenFieldSample4.name = "organization";
      hiddenFieldSample4.value = "user.songjukti.com";
      form.appendChild(hiddenFieldSample4);

      const hiddenFieldSample7 = document.createElement("input");
      hiddenFieldSample7.type = "hidden";
      hiddenFieldSample7.name = "return_url";
      hiddenFieldSample7.value = "https://user.songjukti.com/payStatus/";
      form.appendChild(hiddenFieldSample7);
    }
    if (selectedMethod?.name == "bKash") {
      form.action = "https://pay.ghorami.com/new_bkash/newPay.php";
      // console.log("singleHitted");
      // Sample 1
      // const hiddenFieldSample1 = document.createElement("input");
      // hiddenFieldSample1.type = "hidden";
      // hiddenFieldSample1.name = "cname";
      // // hiddenFieldSample1.value = fetchedName?.slice(0, 7);
      // hiddenFieldSample1.value = sopnoId?.slice(0, 7);
      // form.appendChild(hiddenFieldSample1);

      // Sample 2
      const hiddenFieldSample2 = document.createElement("input");
      hiddenFieldSample2.type = "hidden";
      hiddenFieldSample2.name = "amount";
      hiddenFieldSample2.value = currentAmount;
      form.appendChild(hiddenFieldSample2);
      // Sample 2

      const hiddenFieldSample3 = document.createElement("input");
      hiddenFieldSample3.type = "hidden";
      hiddenFieldSample3.name = "order_id";
      hiddenFieldSample3.value = getRefer;
      // hiddenFieldSample3.value = Math.round(Math.random() * 1000000000 + 1);
      form.appendChild(hiddenFieldSample3);

      // Sample 2
      const hiddenFieldSample4 = document.createElement("input");
      hiddenFieldSample4.type = "hidden";
      hiddenFieldSample4.name = "pay_rReference";
      hiddenFieldSample4.value = "user.songjukti.com";
      form.appendChild(hiddenFieldSample4);

      const hiddenFieldSample5 = document.createElement("input");
      hiddenFieldSample5.type = "hidden";
      hiddenFieldSample5.name = "intent";
      hiddenFieldSample5.value = "sale";
      form.appendChild(hiddenFieldSample5);

      const hiddenFieldSample6 = document.createElement("input");
      hiddenFieldSample6.type = "hidden";
      hiddenFieldSample6.name = "portal";
      hiddenFieldSample6.value = "user.songjukti.com";
      // hiddenFieldSample6.value = "sopno";
      form.appendChild(hiddenFieldSample6);

      const hiddenFieldSample7 = document.createElement("input");
      hiddenFieldSample7.type = "hidden";
      hiddenFieldSample7.name = "agreement_id";
      hiddenFieldSample7.value = "122030";
      form.appendChild(hiddenFieldSample7);

      const hiddenFieldSample9 = document.createElement("input");
      hiddenFieldSample9.type = "hidden";
      hiddenFieldSample9.name = "return_url";
      hiddenFieldSample9.value = "https://user.songjukti.com/payStatus/";
      form.appendChild(hiddenFieldSample9);
    }

    if (
      selectedMethod?.name == "mastercard" ||
      selectedMethod?.name == "nexus" ||
      selectedMethod?.name == "dbdebit" ||
      selectedMethod?.name == "visa" ||
      selectedMethod?.name == "ghorami"
    ) {
      form.action = "https://stripe.ghorami.com/pay";
      // Sample 1
      const hiddenFieldSample1 = document.createElement("input");
      hiddenFieldSample1.type = "hidden";
      hiddenFieldSample1.name = "name";
      hiddenFieldSample1.value = name;
      form.appendChild(hiddenFieldSample1);

      // Sample 2
      const hiddenFieldSample2 = document.createElement("input");
      hiddenFieldSample2.type = "hidden";
      hiddenFieldSample2.name = "phone";
      hiddenFieldSample2.value = phone;
      form.appendChild(hiddenFieldSample2);
      // Sample 2
      const hiddenFieldSample3 = document.createElement("input");
      hiddenFieldSample3.type = "hidden";
      hiddenFieldSample3.name = "amount";
      hiddenFieldSample3.value = currentAmount;
      form.appendChild(hiddenFieldSample3);
      // Sample 2
      const hiddenFieldSample4 = document.createElement("input");
      hiddenFieldSample4.type = "hidden";
      hiddenFieldSample4.name = "currency";
      hiddenFieldSample4.value =
        currentCurrency == 1 ? "BDT" : currentCurrency == 2 ? "USD" : "AED";
      form.appendChild(hiddenFieldSample4);
      // Sample 2
      const hiddenFieldSample5 = document.createElement("input");
      hiddenFieldSample5.type = "hidden";
      hiddenFieldSample5.name = "address";
      hiddenFieldSample5.value = address;
      form.appendChild(hiddenFieldSample5);
      // Sample 2
      const hiddenFieldSample6 = document.createElement("input");
      hiddenFieldSample6.type = "hidden";
      hiddenFieldSample6.name = "email";
      hiddenFieldSample6.value = email;
      form.appendChild(hiddenFieldSample6);

      const hiddenFieldSample7 = document.createElement("input");
      hiddenFieldSample7.type = "hidden";
      hiddenFieldSample7.name = "order_id";
      hiddenFieldSample7.value = getRefer;
      // hiddenFieldSample7.value = Math.round(Math.random() * 1000000000 + 1);
      form.appendChild(hiddenFieldSample7);

      const hiddenFieldSample8 = document.createElement("input");
      hiddenFieldSample8.type = "hidden";
      hiddenFieldSample8.name = "logo_url";
      hiddenFieldSample8.value =
        "https://aps.songjukti.com/static/media/songjukti.064fb2e32388b8ea26c2.ico";
      form.appendChild(hiddenFieldSample8);

      const hiddenFieldSample10 = document.createElement("input");
      hiddenFieldSample10.type = "hidden";
      hiddenFieldSample10.name = "brand_text";
      hiddenFieldSample10.value = "songjukti.com";
      form.appendChild(hiddenFieldSample10);

      const hiddenFieldSample9 = document.createElement("input");
      hiddenFieldSample9.type = "hidden";
      hiddenFieldSample9.name = "return_url";
      hiddenFieldSample9.value = "https://user.songjukti.com/payStatus/";
      form.appendChild(hiddenFieldSample9);
    }
    if (selectedMethod?.name == "paypal") {
      form.action = "http://paypal.ghorami.com/products/buyProduct";
      // Sample 1
      const hiddenFieldSample1 = document.createElement("input");
      hiddenFieldSample1.type = "hidden";
      hiddenFieldSample1.name = "cus_name";
      // hiddenFieldSample1.value = "ntest";
      hiddenFieldSample1.value = name;
      form.appendChild(hiddenFieldSample1);

      // Sample 2
      const hiddenFieldSample2 = document.createElement("input");
      hiddenFieldSample2.type = "hidden";
      hiddenFieldSample2.name = "item_name";
      hiddenFieldSample2.value = "songjukti_us";
      // hiddenFieldSample2.value = phone;
      form.appendChild(hiddenFieldSample2);
      // Sample 2
      const hiddenFieldSample3 = document.createElement("input");
      hiddenFieldSample3.type = "hidden";
      hiddenFieldSample3.name = "amount";
      // hiddenFieldSample3.value = "45";
      hiddenFieldSample3.value = currentAmount;
      form.appendChild(hiddenFieldSample3);
      // Sample 2
      const hiddenFieldSample4 = document.createElement("input");
      hiddenFieldSample4.type = "hidden";
      hiddenFieldSample4.name = "currency";
      hiddenFieldSample4.value = "USD";
      // hiddenFieldSample4.value = currentCurrency;
      form.appendChild(hiddenFieldSample4);
      // Sample 2
      const hiddenFieldSample5 = document.createElement("input");
      hiddenFieldSample5.type = "hidden";
      hiddenFieldSample5.name = "orgranization";
      hiddenFieldSample5.value = "user.songjukti.com";
      form.appendChild(hiddenFieldSample5);
      // Sample 2
      const hiddenFieldSample6 = document.createElement("input");
      hiddenFieldSample6.type = "hidden";
      hiddenFieldSample6.name = "cus_email";
      // hiddenFieldSample6.value = "tpu@ghorami.com";
      hiddenFieldSample6.value = email;
      form.appendChild(hiddenFieldSample6);

      const hiddenFieldSample7 = document.createElement("input");
      hiddenFieldSample7.type = "hidden";
      hiddenFieldSample7.name = "order_id";
      hiddenFieldSample7.value = getRefer;
      // hiddenFieldSample7.value = Math.round(Math.random() * 1000000000 + 1);
      form.appendChild(hiddenFieldSample7);

      const hiddenFieldSample9 = document.createElement("input");
      hiddenFieldSample9.type = "hidden";
      hiddenFieldSample9.name = "return_url";
      hiddenFieldSample9.value = "https://user.songjukti.com/payStatus/";
      form.appendChild(hiddenFieldSample9);

      const hiddenFieldSample8 = document.createElement("input");
      hiddenFieldSample8.type = "hidden";
      hiddenFieldSample8.name = "logo_url";
      hiddenFieldSample8.value =
        "https://aps.songjukti.com/static/media/songjukti.064fb2e32388b8ea26c2.ico";
      form.appendChild(hiddenFieldSample8);

      const hiddenFieldSample10 = document.createElement("input");
      hiddenFieldSample10.type = "hidden";
      hiddenFieldSample10.name = "brand_text";
      hiddenFieldSample10.value = "user.songjukti.com";
      form.appendChild(hiddenFieldSample10);
    }

    document.body.appendChild(form);
    form.submit();
  };
  const handleConfirm = () => {
    const formData = new FormData();
    formData.append("user_id",user?.sopnoid);
    formData.append("accn_id", user?.sopnoid);
    formData.append("amount", currentAmount);
    formData.append("currency", currentCurrency);
    formData.append(
      "trnx_id",
      getRefer ? getRefer : Math.round(Math.random() * 1000000000)
    );
    formData.append("pay_method", selectedMethod.name);

    fetch(
      `https://aps.songjukti.com/profile/ac_bil/api_web/new/neb_bal_confirm.php`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result?.[0]?.resultState == "Success") {
          setToggleDisplay(false);
          handleClose();
          afterHit();
        }
      })
      .catch((error) => console.log("FetchUserApiError=> ", error));
  };

  return (
    <div>
      <Modal
        onClose={handleClose}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open2}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open2}>
          <Box
            sx={[
              {
                ...style,
                "@media (max-width:768px)": {
                  width: "98%",
                },
              },
            ]}
          >
            <Box sx={{ width: "100%", position: "relative" }}>
              {!toggleDisplay && (
                <Box
                  sx={{
                    fontSize: "1.5rem",
                    color: "red",
                    cursor: "pointer",
                    position: "absolute",
                    right: "-5px",
                    top: "5px",
                  }}
                  onClick={() => {
                    handleClose();
                    route && navigate("/" + route);
                  }}
                >
                  <MdCancel />
                </Box>
              )}
              {!toggleDisplay ? (
                <>
                  <Grid
                    container
                    spacing={2}
                    mb={2}
                    sx={{ width: { xs: "100%", md: "90%" } }}
                  >
                    <Grid item xs={12} md={4}>
                      <Stack spacing={0.4}>
                        {" "}
                        <Typography
                          variant="p"
                          sx={{ fontSize: "11pt", fontWeight: 700 }}
                        >
                          Amount to pay
                        </Typography>
                        <Box
                          sx={{
                            padding: "2px",
                            border: "1px solid #d1cfcf",
                            width: "100%",
                            borderRadius: "4px",
                          }}
                        >
                          <Stack>
                            <Typography
                              variant="p"
                              sx={{
                                fontSize: "8pt",
                                fontWeight: 700,
                                color: "gray",
                              }}
                            >
                              Total amount due
                            </Typography>
                            <Typography
                              variant="p"
                              sx={{ fontSize: "9pt", fontWeight: 700 }}
                            >
                              {currentCurrency == 1
                                ? "BDT"
                                : currentCurrency == 2
                                ? "USD"
                                : "AED"}{" "}
                              {currentAmount}
                            </Typography>{" "}
                          </Stack>
                        </Box>
                      </Stack>
                    </Grid>
                    {payAmoOn && (
                      <Grid item xs={12} md={4}>
                        <Stack
                          spacing={-0.2}
                          alignItems={"flex-start"}
                          justifyContent={"center"}
                        >
                          <Typography
                            variant="p"
                            sx={{
                              fontSize: "11pt",
                              fontWeight: 700,
                            }}
                          >
                            Pay Amount{" "}
                          </Typography>
                          <OutlinedInput
                            placeholder="Pay Amount"
                            size="medium"
                            type="number"
                            sx={{ width: "100%" }}
                            onChange={handlePayAmount}
                          />
                        </Stack>
                      </Grid>
                    )}

                    <Grid item xs={12} md={4}>
                      <Stack spacing={-0.2}>
                        {" "}
                        <Typography
                          variant="p"
                          sx={{
                            fontSize: "11pt",
                            fontWeight: 700,
                            // marginTop: "10px",
                          }}
                        >
                          Select Currency
                        </Typography>
                        {!payAmoOn && (
                          <Select
                            size="medium"
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                          value={JSON.stringify(currentCurrency)}// ✅ use `value`, not `defaultValue`
                            onChange={handleCurrentCurrencyChange}
                            sx={{ width: "100%" }}
                          >
                            <MenuItem
                              value={{
                                currency: 1,
                                amount: paymentInfo?.BDT,
                              }}
                            >
                              BDT
                            </MenuItem>
                            <MenuItem
                              value={{
                                currency: 2,
                                amount: paymentInfo?.USD,
                              }}
                            >
                              USD
                            </MenuItem>
                            <MenuItem
                              value={{
                                currency: 3,
                                amount: paymentInfo?.AED,
                              }}
                            >
                              AED
                            </MenuItem>
                          </Select>
                        )}
                        {payAmoOn && (
                          <Select
                            name="template"
                            size="small"
                            displayEmpty
                             value={currentCurrency}
                            inputProps={{ "aria-label": "Without label" }}
                            onChange={handleCurrencyChange}
                            sx={{ width: "100%" }}
                          >
                            <MenuItem value={1}>BDT</MenuItem>
                            <MenuItem value={2}>USD</MenuItem>
                            <MenuItem value={3}>AED</MenuItem>
                          </Select>
                        )}
                      </Stack>
                    </Grid>
                    {payAmoOn && (
                      <Grid item xs={12} md={6}>
                        <Stack
                          direction={"row"}
                          justifyContent="left"
                          alignItems="center"
                          spacing={1}
                          sx={{ marginBottom: "10px", marginTop: "-5px" }}
                        >
                          <Button
                            size="small"
                            sx={{ textTransform: "capitalize", width: "100px" }}
                            onClick={() => {
                              setShowNoteField(!showNoteField);
                            }}
                          >
                            {showNoteField ? "hide note" : "Add note"}
                          </Button>
                          {showNoteField && (
                            <OutlinedInput
                              placeholder="Note"
                              type="text"
                              sx={{
                                width: "200px",
                              }}
                              onChange={(e) => {
                                setMemo(e.target.value);
                              }}
                            />
                          )}
                        </Stack>
                      </Grid>
                    )}
                  </Grid>
                  {/* <Stack direction={"row"} justifyContent="space-between">
                  <Stack spacing={1} mb={2}>
                    <Stack
                      direction={"row"}
                      justifyContent="space-between"
                      alignItems="flex-end"
                      sx={{
                        width: payAmoOn ? "93%" : "90%",
                        marginBottom: payAmoOn ? "-4px" : "-8px",
                      }}
                    >
                      <Typography
                        variant="p"
                        sx={{ fontSize: "11pt", fontWeight: 700 }}
                      >
                        Amount to pay
                      </Typography>
                      {payAmoOn && (
                        <Typography
                          variant="p"
                          sx={{
                            fontSize: "11pt",
                            fontWeight: 700,
                            marginLeft: "45px",
                          }}
                        >
                          Pay Amount{" "}
                        </Typography>
                      )}
                      <Typography
                        variant="p"
                        sx={{ fontSize: "11pt", fontWeight: 700 }}
                      >
                        Select Currency
                      </Typography>
                    </Stack>

                    <Stack
                      spacing={2}
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems="flex-start"
                    >
                      <Box
                        sx={{
                          padding: "5px",
                          border: "1px solid #d1cfcf",
                          width: "200px",
                          borderRadius: "4px",
                        }}
                      >
                        <Stack>
                          <Typography
                            variant="p"
                            sx={{
                              fontSize: "8pt",
                              fontWeight: 700,
                              color: "gray",
                            }}
                          >
                            Total amount due
                          </Typography>
                          <Typography
                            variant="p"
                            sx={{ fontSize: "9pt", fontWeight: 700 }}
                          >
                            {currentCurrency == 1
                              ? "BDT"
                              : currentCurrency == 2
                              ? "USD"
                              : "AED"}{" "}
                            {currentAmount}
                          </Typography>{" "}
                        </Stack>
                      </Box>

                      {payAmoOn && (
                        <OutlinedInput
                          placeholder="Pay Amount"
                          type="number"
                          sx={{ width: "140px" }}
                          onChange={handlePayAmount}
                        />
                      )}

                      {!payAmoOn && (
                        <Select
                          name="template"
                          size="small"
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          value={currentAmount}
                          onChange={handleCurrentCurrencyChange}
                          sx={{ width: "150px" }}
                        >
                          <MenuItem
                            value={{
                              currency: 1,
                              amount: paymentInfo?.BDT,
                            }}
                          >
                            BDT
                          </MenuItem>
                          <MenuItem
                            value={{
                              currency: 2,
                              amount: paymentInfo?.USD,
                            }}
                          >
                            USD
                          </MenuItem>
                          <MenuItem
                            value={{
                              currency: 3,
                              amount: paymentInfo?.AED,
                            }}
                          >
                            AED
                          </MenuItem>
                        </Select>
                      )}

                      {payAmoOn && (
                        <Select
                          name="template"
                          size="small"
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          onChange={handleCurrencyChange}
                          sx={{ width: "150px" }}
                        >
                          <MenuItem value={1}>BDT</MenuItem>
                          <MenuItem value={2}>USD</MenuItem>
                          <MenuItem value={3}>AED</MenuItem>
                        </Select>
                      )}
                    </Stack>
                  </Stack>
                  <Box
                    sx={{
                      fontSize: "1.5rem",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={handleClose}
                  >
                    <MdCancel />
                  </Box>
                </Stack> */}

                  {/* {payAmoOn && (
                  <Stack
                    direction={"row"}
                    justifyContent="left"
                    alignItems="center"
                    spacing={1}
                    sx={{ marginBottom: "10px", marginTop: "-5px" }}
                  >
                    <Button
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                      onClick={() => {
                        setShowNoteField(!showNoteField);
                      }}
                    >
                      {showNoteField ? "hide note" : "Add note"}
                    </Button>
                    {showNoteField && (
                      <OutlinedInput
                        placeholder="Note"
                        type="text"
                        sx={{
                          width: "200px",
                        }}
                        onChange={(e) => {
                          setMemo(e.target.value);
                        }}
                      />
                    )}
                  </Stack>
                )} */}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        mb: 3,
                      }}
                    >
                      {currentCurrency == 1 && (
                        <Button
                          variant="contained"
                          color={component == "Wallet" ? "warning" : "primary"}
                          sx={{
                            mr: 2,
                          }}
                          onClick={() => {
                            setComponent("Wallet");
                          }}
                        >
                          Wallet
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        color={component == "Card" ? "warning" : "primary"}
                        sx={{ mr: 2 }}
                        onClick={() => {
                          setComponent("Card");
                        }}
                      >
                        Card
                      </Button>

                      <Button
                        variant="contained"
                        color={
                          component == "International" ? "warning" : "primary"
                        }
                        onClick={() => {
                          setComponent("International");
                        }}
                      >
                        International
                      </Button>
                    </Box>
                  </Box>
                  <Box>
                    {component == "Wallet" && currentCurrency == 1 && (
                      <Wallet
                        amount={currentAmount}
                        note={note}
                        setToggleDisplay={setToggleDisplay}
                        payAmoOn={payAmoOn}
                        handleSaveInServer={handleSaveInServer}
                        setSelectedMethod={setSelectedMethod}
                      />
                    )}
                    {component == "Card" && (
                      <Card
                        amount={currentAmount}
                        note={note}
                        payAmoOn={payAmoOn}
                        handleSaveInServer={handleSaveInServer}
                        setToggleDisplay={setToggleDisplay}
                        setSelectedMethod={setSelectedMethod}
                      />
                    )}
                    {component == "International" && (
                      <International
                        amount={currentAmount}
                        note={note}
                        payAmoOn={payAmoOn}
                        handleSaveInServer={handleSaveInServer}
                        setToggleDisplay={setToggleDisplay}
                        setSelectedMethod={setSelectedMethod}
                        currentCurrency={currentCurrency}
                      />
                    )}
                  </Box>
                </>
              ) : (
                <Stack spacing={1}>
                  <Stack
                    direction={"row"}
                    justifyContent="space-between"
                    alignItems={"center"}
                  >
                    <IconButton
                      aria-label="delete"
                      size="small"
                      sx={{ marginTop: "-30px" }}
                      onClick={() => {
                        setToggleDisplay(false);
                      }}
                    >
                      <ArrowBackIos fontSize="small" />
                    </IconButton>
                    <Typography variant="p" sx={{ fontWeight: 600 }}>
                      Review your payment
                    </Typography>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      sx={{ marginTop: "-30px" }}
                      onClick={() => {
                        handleClose();
                        route && navigate("/" + route);
                      }}
                    >
                      <Clear fontSize="small" />
                    </IconButton>
                  </Stack>
                  <Stack
                    spacing={1}
                    direction={"row"}
                    justifyContent="left"
                    alignItems={"center"}
                    sx={{ paddingX: "40%" }}
                  >
                    <img
                      src={selectedMethod.image}
                      alt=""
                      style={{
                        width: "35px",
                        // margin: "0 5px",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                    />
                    <ArrowRightAlt />
                    <AccountBalanceWallet
                      sx={{ fontSize: "22pt", color: "#0aa5a5" }}
                    />
                  </Stack>

                  <Stack>
                    <Typography
                      variant="p"
                      sx={{ fontWeight: 600, textAlign: "center" }}
                    >
                      You are paying{" "}
                      {currentCurrency == 1
                        ? "BDT"
                        : currentCurrency == 2
                        ? "USD"
                        : "AED"}{" "}
                      {currentAmount}
                    </Typography>
                    <Typography
                      variant="p"
                      sx={{ fontSize: "12pt", textAlign: "center" }}
                    >
                      You are paying with {selectedMethod.name} and your new
                      balance will be{" "}
                      {currentCurrency == 1
                        ? "BDT"
                        : currentCurrency == 2
                        ? "USD"
                        : "AED"}{" "}
                      {parseFloat(dueAmount) - parseFloat(currentAmount)}
                    </Typography>
                  </Stack>

                  <Stack direction={"row"} justifyContent={"right"}>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                      onClick={handleConfirm}
                    >
                      Confirm
                    </Button>
                  </Stack>
                </Stack>
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default PaymentMethodCashInModal;
